import { Grid } from "@material-ui/core";
import AddressDataForm from "../../../../forms/shared/AddressDataForm";
import FormBase from "../../../../forms/FormBase";
import { useEffect, useState } from "react";
import AddressService from "../../../../services/AddressService";
import React from "react";
import TmpInputCustom, { InputMaskProps } from "../../../../components/tempo/TmpInputCustom/TmpInputCustom";
import TmpInputSelectSearchCustom from "../../../../components/tempo/TmpInputSelectSearchCustom/TmpInputSelectSearchCustom";
import OptionItem from "../../../../models/OptionItem";

interface AddressDataComponentProps {
  AddressDataForm: AddressDataForm;
  onInputChange: (name: string, form: FormBase, value: any) => void;
}

export default function AddressDataComponent(props: AddressDataComponentProps) {
  const [statesStateOptions, setStatesStateOptions] = useState<OptionItem[]>([]);

  useEffect(() => {
    AddressService.getAllStatesOptions().then((e) => setStatesStateOptions(e));
  }, []);


  const useIsMounted = () => {
    const isMounted = React.useRef(false);
    React.useEffect(() => {
      isMounted.current = true;

      if (props.AddressDataForm.CEP.Value.length > 8) {
        if (statesStateOptions && statesStateOptions.length === 0) {
          AddressService.getAllStatesOptions().then((states) => {
            AddressService.getAddressByCEP(props.AddressDataForm.CEP.Value.replace("-", "")).then(e => {
              if (e.addressName != null) props.onInputChange("Address", props.AddressDataForm, e.addressName)
              if (e.neighborhood != null) props.onInputChange("Neighborhood", props.AddressDataForm, e.neighborhood)
              if (e.city != null) props.onInputChange("City", props.AddressDataForm, e.city)
              if (e.complement != null) props.onInputChange("Complement", props.AddressDataForm, e.complement)
              if (e.state != null) props.onInputChange("State", props.AddressDataForm, states.find((state: OptionItem) => state.Value === e.state))
            })
          });
        } else {
          AddressService.getAddressByCEP(props.AddressDataForm.CEP.Value.replace("-", "")).then(e => {
            if (e.addressName != null) props.onInputChange("Address", props.AddressDataForm, e.addressName)
            if (e.neighborhood != null) props.onInputChange("Neighborhood", props.AddressDataForm, e.neighborhood)
            if (e.city != null) props.onInputChange("City", props.AddressDataForm, e.city)
            if (e.complement != null) props.onInputChange("Complement", props.AddressDataForm, e.complement)
            if (e.state != null) props.onInputChange("State", props.AddressDataForm, statesStateOptions.find(r => r.Value === e.state))
          })
        }
      }

      return () => {
        isMounted.current = false;
      };
    }, []);
    return isMounted;
  };

  useIsMounted();

  const onChangeOrBlurCEP = (e: any) => {
    props.onInputChange("CEP", props.AddressDataForm, e.target.value);

    let cepValue = e.target.value;

    if (cepValue.length > 8) {
      if (statesStateOptions && statesStateOptions.length === 0) {
        AddressService.getAllStatesOptions().then((states) => {
          AddressService.getAddressByCEP(cepValue.replace("-", "")).then(e => {
            if (e.addressName != null) props.onInputChange("Address", props.AddressDataForm, e.addressName)
            if (e.neighborhood != null) props.onInputChange("Neighborhood", props.AddressDataForm, e.neighborhood)
            if (e.city != null) props.onInputChange("City", props.AddressDataForm, e.city)
            if (e.complement != null) props.onInputChange("Complement", props.AddressDataForm, e.complement)
            if (e.state != null) props.onInputChange("State", props.AddressDataForm, states.find((state: OptionItem) => state.Value === e.state))
          })
        });
      } else {
        AddressService.getAddressByCEP(cepValue.replace("-", "")).then(e => {
          if (e.addressName != null) props.onInputChange("Address", props.AddressDataForm, e.addressName)
          if (e.neighborhood != null) props.onInputChange("Neighborhood", props.AddressDataForm, e.neighborhood)
          if (e.city != null) props.onInputChange("City", props.AddressDataForm, e.city)
          if (e.complement != null) props.onInputChange("Complement", props.AddressDataForm, e.complement)
          if (e.state != null) props.onInputChange("State", props.AddressDataForm, statesStateOptions.find((r: OptionItem) => r.Value === e.state))
        })
      }
    }

  }

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={3} sm={3}>
          <TmpInputCustom
            id="CEP"
            label="CEP"
            name="CEP"
            maxLength={9}
            mask={InputMaskProps.CEP}
            mandatory={props.AddressDataForm.CEP.Mandatory}
            placeholder="CEP"
            value={props.AddressDataForm.CEP.Value}
            type="text"
            onChange={onChangeOrBlurCEP}
            onBlur={onChangeOrBlurCEP}
            error={props.AddressDataForm.CEP.HasError()}
            helperText={props.AddressDataForm.CEP.Error}
          />

        </Grid>

        <Grid item xs={6}>

          <TmpInputCustom
            id="Address"
            name="Address"
            label="Rua"
            maxLength={100}
            mandatory={props.AddressDataForm.Address.Mandatory}
            placeholder="Digite sua rua"
            value={props.AddressDataForm.Address.Value}
            type="text"
            onChange={(e) => { props.onInputChange("Address", props.AddressDataForm, e.target.value) }}
            onBlur={(e) => { props.onInputChange("Address", props.AddressDataForm, e.target.value) }}
            error={props.AddressDataForm.CEP.HasError()}
            helperText={props.AddressDataForm.CEP.Error}
          />

        </Grid>

        <Grid item xs={3}>
          <TmpInputCustom
            id="Number"
            name="Number"
            label="Número"
            maxLength={8}
            mask={InputMaskProps.NUMERICO}
            mandatory={props.AddressDataForm.Number.Mandatory}
            placeholder="Digite o número"
            value={props.AddressDataForm.Number.Value}
            type="text"
            onChange={(e) => { props.onInputChange("Number", props.AddressDataForm, e.target.value) }}
            onBlur={(e) => { props.onInputChange("Number", props.AddressDataForm, e.target.value) }}
            error={props.AddressDataForm.Number.HasError()}
            helperText={props.AddressDataForm.Number.Error}
          />
        </Grid>

        <Grid item xs={6}>
          <TmpInputCustom
            id="Neighborhood"
            name="Neighborhood"
            label="Bairro"
            maxLength={80}
            mandatory={props.AddressDataForm.Neighborhood.Mandatory}
            placeholder="Digite seu bairro"
            value={props.AddressDataForm.Neighborhood.Value}
            type="text"
            onChange={(e) => { props.onInputChange("Neighborhood", props.AddressDataForm, e.target.value) }}
            onBlur={(e) => { props.onInputChange("Neighborhood", props.AddressDataForm, e.target.value) }}
            error={props.AddressDataForm.Neighborhood.HasError()}
            helperText={props.AddressDataForm.Neighborhood.Error}
          />
        </Grid>



        <Grid item xs={6}>

          <TmpInputCustom
            id="Complement"
            name="Complement"
            label="Complemento"
            maxLength={40}
            mandatory={props.AddressDataForm.Complement.Mandatory}
            placeholder="Digite o complemento"
            value={props.AddressDataForm.Complement.Value}
            type="text"
            onChange={(e) => { props.onInputChange("Complement", props.AddressDataForm, e.target.value) }}
            onBlur={(e) => { props.onInputChange("Complement", props.AddressDataForm, e.target.value) }}
            error={props.AddressDataForm.Complement.HasError()}
            helperText={props.AddressDataForm.Complement.Error}
          />

        </Grid>

        <Grid item xs={6}>

          <TmpInputCustom
            id="City"
            name="City"
            label="Cidade"
            maxLength={40}
            mandatory={props.AddressDataForm.City.Mandatory}
            placeholder="Digite sua cidade"
            value={props.AddressDataForm.City.Value}
            type="text"
            onChange={(e) => { props.onInputChange("City", props.AddressDataForm, e.target.value) }}
            onBlur={(e) => { props.onInputChange("City", props.AddressDataForm, e.target.value) }}
            error={props.AddressDataForm.City.HasError()}
            helperText={props.AddressDataForm.City.Error}
          />

        </Grid>

        <Grid item xs={6}>
          <TmpInputSelectSearchCustom
            label="Estado"
            name="State"
            id="State"
            mandatory={props.AddressDataForm.City.Mandatory}
            placeholder="Selecione"
            itens={statesStateOptions}
            value={props.AddressDataForm.State.Value}
            onChange={(e) => { props.onInputChange("State", props.AddressDataForm, e.target.value) }}
            onBlur={(e) => { props.onInputChange("State", props.AddressDataForm, e.target.value) }}
            error={props.AddressDataForm.State.HasError()}
            helperText={props.AddressDataForm.State.Error}
          />

        </Grid>
      </Grid>
    </div>
  );
}
